/* artvision® · Navigation einzeilig halten
   Passt die Hauptnavigation nicht in eine Zeile, werden die letzten
   Einträge ausgeblendet (statt umzubrechen). Wird es wieder breiter,
   kommen sie zurück. Im mobilen Menü bleibt alles erreichbar. */
(function () {
  function fit() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;
    var list = nav.querySelector('.list-menu--inline');
    if (!list) return;
    var items = Array.prototype.slice.call(list.children);
    items.forEach(function (li) { li.classList.remove('av-nav-hidden'); });
    if (!nav.offsetParent) return; /* Desktop-Menü gerade ausgeblendet */

    /* Grenze: Beginn der Icons. Falls die einzeilige Liste die Icons
       schon aus dem Bild schiebt, zählt die rechte Kante des Headers
       abzüglich Icon-Breite. */
    var header = nav.closest('header') || document.documentElement;
    var icons = header.querySelector('.header__icons');
    var hr = Math.min(header.getBoundingClientRect().right, document.documentElement.clientWidth);
    var iw = icons ? icons.getBoundingClientRect().width : 0;
    var limit = Math.min(icons ? icons.getBoundingClientRect().left : hr, hr - iw) - 24;

    for (var i = items.length - 1; i > 0; i--) {
      var visible = items.filter(function (li) { return !li.classList.contains('av-nav-hidden'); });
      var last = visible[visible.length - 1];
      if (last.getBoundingClientRect().right <= limit) break;
      last.classList.add('av-nav-hidden');
    }
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(fit, 60); }
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit);
  else fit();
  document.addEventListener('shopify:section:load', schedule);
})();
